export const jobs = [
  {
    title: 'Gen AI Executive Intern',
    company: 'HelloFresh',
    location: 'New York, NY',
    period: 'July 2026 – Present',
    description:
      " Embedded with the executive team at HelloFresh, reporting to the Chief of Staff to the President & North America CEO. Built a Streamlit dashboard pulling from Snowflake and Databricks for the biweekly executive sync, and used LangChain and Claude to prototype Gen AI tools aimed at streamlining workflows for the company's core business. Function as a rapid-execution resource, turning ambiguous, high-stakes research asks into shipped tools and decisions leadership can act on in days, not months.",
    techStack:
      'Claude, SQL, Databricks, Python, LangChain, Snowflake, Streamlit',
  },
  {
    title: 'Technical Co-Founder',
    company: 'Zane',
    location: 'Remote',
    period: 'September 2025 – July 2026',
    description:
      'Co-founding an ML-powered platform that matches creators and brands with direct performance-based payouts. Built the core similarity engine using vector embeddings and integrated Stripe for automated payouts. Driving key product and technical decisions and pitching to investors.',
    techStack:
      'React, TailwindCSS, Vite, PostgreSQL, Express.js, Supabase, Stripe, Railway, Netlify',
  },
  {
    title: 'Data Science Intern',
    company: 'Eaton',
    location: 'Dublin, Ireland',
    period: 'January 2025 – September 2025',
    description:
      'Developed and tested machine learning models for industrial applications. Presented results to stakeholders for project validation. Created proprietary data visualization tools.',
    techStack: 'Python, TensorFlow, Pandas, TypeScript',
  },
  {
    title: 'Contracted Research Assistant',
    company: 'Jobs For the Future',
    location: 'Remote',
    period: 'June 2024 – September 2024',
    description:
      'Researched AI job and course search tools to analyze their ethical implications and understand bias in AI tools.',
  },
];
